<template>
  <div class="question-list-container">
    <div class="greeting-card">
      <div class="greeting-header">
        <h2>Hi</h2>
        <p>我是您的AI新朋友-小贝</p>
      </div>
      <p class="description">
        您可以聊些关于商场的各类问题，您可以试试问我：品牌查找、会员服务、积分位置、商场艺术博物馆资讯等。
      </p>
      <button class="refresh-btn" @click="refreshQuestions">🔄 换一换</button>
    </div>

    <div class="questions-grid">
      <div v-for="(q, index) in displayedQuestions" :key="index" class="question-item">
        <span>{{ q }}</span>
        <button class="ask-btn" @click="$emit('ask-question', q)">问问</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionList',
  emits: ['ask-question'],
  data() {
    return {
      questionPool: [
        "星巴克在什么位置",
        "会员怎么办理",
        "我想查一下我的会员积分",
        "我想找车？",
        "我想买个大衣",
        "商场的营业时间",
        "最近有什么优惠活动",
        "哪里有洗手间",
        "母婴室在哪里",
        "我想吃火锅",
        "电影院在几楼",
        "客服中心在哪里"
      ],
      displayedQuestions: []
    }
  },
  mounted() {
    this.refreshQuestions();
  },
  methods: {
    refreshQuestions() {
      // Shuffle array
      const shuffled = [...this.questionPool].sort(() => 0.5 - Math.random());
      // Get first 4
      this.displayedQuestions = shuffled.slice(0, 4);
    }
  }
}
</script>

<style scoped>
.question-list-container {
  display: flex;
  flex-direction: column;
  gap: 1vh; /* Reduced */
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 1vh 1vw; /* Reduced */
  backdrop-filter: blur(10px);
  box-sizing: border-box;
}

.greeting-card {
  flex: 0 0 auto;
  background: rgba(255, 255, 255, 0.3);
  padding: 1vh 1vw; /* Reduced */
  border-radius: 15px;
  position: relative;
  color: #fff;
}

.greeting-header h2 {
  font-size: 2rem; /* Reduced */
  margin: 0;
  line-height: 1;
}

.description {
  font-size: 0.75rem; /* Reduced */
  opacity: 0.9;
  margin-top: 0.5vh; /* Reduced */
  max-width: 85%;
  line-height: 1.2;
}

.refresh-btn {
  position: absolute;
  top: 1vh;
  right: 1vw;
  background: rgba(255, 255, 255, 0.3);
  border: none;
  padding: 3px 10px;
  border-radius: 20px;
  color: #fff;
  cursor: pointer;
  font-size: 0.7rem;
}

.questions-grid {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Distribute vertically */
  min-height: 0;
  padding-top: 0.5vh;
}

.question-item {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  padding: 0 1vw;
  margin-bottom: 0.5vh; /* Reduced */
  border-radius: 50px;
  color: #5aa1a5;
  font-weight: bold;
  font-size: 0.8rem; /* Slightly smaller text */
}
.question-item:last-child {
  margin-bottom: 0;
}

.ask-btn {
  background: #d4cf5f;
  color: #fff;
  border: none;
  padding: 3px 10px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: bold;
  white-space: nowrap;
  font-size: 0.7rem;
}
</style>
